import { dripMediumOptionsWithEmail, dripMediumOptionsWithText } from 'features/CustomCampaigns/EditCampaign/CampaignSetup'
import { ReactComponent as EmailIcon } from 'features/CartAbandonmentFlow/email.svg'
import { ReactComponent as SmsIcon } from 'features/CartAbandonmentFlow/sms.svg'

import styles from './DripStepCard.module.scss'

function DripStepCard({
  stepNumber,
  title,
  messagePreview,
  isActive = true,
  hasEmailCampaign = true,
  medium,
  errorMessage,
  isDisabledByPrevious = false,
  isInitialStep = false,
  onClick
}) {
  const cardClassNames = [
    styles.card,
    !isActive && styles.inactive,
    isDisabledByPrevious && styles.disabledByPrevious,
    errorMessage && styles.hasError
  ]
    .filter(Boolean)
    .join(' ')

  const showSmsIcon = dripMediumOptionsWithText.includes(medium)
  const showEmailIcon = dripMediumOptionsWithEmail.includes(medium)

  const emailIconClassName = hasEmailCampaign
    ? styles.channelIcon
    : `${styles.channelIcon} ${styles.channelIconDisabled}`

  const handleClick = isDisabledByPrevious ? undefined : onClick

  return (
    <div className={cardClassNames} onClick={handleClick}>
      <div className={styles.cardContent}>
        <span className={styles.stepBadge}>{stepNumber}</span>
        {!hasEmailCampaign && showEmailIcon && (
          <span className={styles.emailNotConfigured}>Email not configured</span>
        )}
        <div className={styles.channelBadges}>
          {showSmsIcon && <SmsIcon className={styles.channelIcon} />}
          {showEmailIcon && <EmailIcon className={emailIconClassName} />}
        </div>
        <div className={styles.title}>{title}</div>
        <div className={styles.messagePreview}>
          <p className={styles.messageText}>{messagePreview}</p>
        </div>
        {errorMessage && <p className={styles.errorMessage}>{errorMessage}</p>}
      </div>
      {isActive && !isDisabledByPrevious ? (
        <div className={styles.statusPanel}>
          <span className={`${styles.statusLabel} ${styles.statusActive}`}>Active</span>
          <span className={styles.statusHint}>
            {isInitialStep
              ? 'Sent when the campaign starts'
              : 'Click to edit delay, content, and channels'}
          </span>
        </div>
      ) : (
        <div className={styles.inactivePanel}>
          <div className={styles.inactiveTitle}>
            {isDisabledByPrevious ? 'Unavailable' : 'Step inactive'}
          </div>
          <div className={styles.inactiveDescription}>
            {isDisabledByPrevious
              ? 'Enable the previous follow-up first'
              : 'Click to enable and configure this step'}
          </div>
        </div>
      )}
    </div>
  )
}

export default DripStepCard
